import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { LandingLinks } from './constants/index.es.js';
import { Global } from '@emotion/react';
import { StoreProvider } from './contexts/StoreContext.es.js';
import { reset } from './constants/reset.es.js';
import { rcCascaderCss } from './constants/rc-cascader.es.js';
import { animationCss } from './constants/animation.es.js';
import { validateIsVisibleComponent } from './utils/date-time.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BuilderComponent = (props) => {
  const {
    content,
    configs,
    ssrData = {},
    mappingDynamicSlots,
    rootId = "ROOT",
    componentDict,
    addGlobalStyle = true
  } = props;
  const renderComponent = (id, apiResponse, restProps, ssrData2) => {
    const compData = apiResponse[id];
    const { tag, startTime, endTime, ruleRepeat, date, duration } = compData;
    const Comp = componentDict[tag];
    if (!Comp) {
      console.warn("Cannot found component: " + tag.toString());
      return null;
    }
    const props2 = __spreadValues(__spreadProps(__spreadValues({}, compData.customAttributes[tag] || {}), {
      commonStyle: compData.style || {},
      id: compData.elementId,
      "data-id": compData.elementId,
      "data-uniq-id": compData.id
    }), restProps);
    const getClassName = () => {
      var _a, _b;
      return clsx({
        "hidden-xs": (_a = props2 == null ? void 0 : props2.responsive) == null ? void 0 : _a.hiddenXs,
        "hidden-md": (_b = props2 == null ? void 0 : props2.responsive) == null ? void 0 : _b.hiddenMd
      });
    };
    const isVisible = validateIsVisibleComponent({
      startTime,
      endTime,
      ruleRepeat,
      date,
      duration
    });
    if (!isVisible)
      return null;
    if (compData.children.length) {
      const currentSSRData2 = ssrData2[compData.id];
      return /* @__PURE__ */ jsx(Comp, __spreadProps(__spreadValues({
        className: getClassName()
      }, props2), {
        ssrData: currentSSRData2,
        children: compData.children.map(
          (childId) => renderComponent(childId, apiResponse, restProps, ssrData2)
        )
      }), compData.id);
    }
    const currentSSRData = ssrData2[compData.id];
    return /* @__PURE__ */ jsx(Comp, __spreadProps(__spreadValues({
      className: getClassName()
    }, props2), {
      ssrData: currentSSRData
    }), compData.id);
  };
  if (!(content == null ? void 0 : content[rootId]))
    return null;
  return /* @__PURE__ */ jsx(StoreProvider, __spreadProps(__spreadValues({
    mappingDynamicSlots
  }, configs), {
    children: /* @__PURE__ */ jsxs(Fragment, {
      children: [
        addGlobalStyle && /* @__PURE__ */ jsxs(Fragment, {
          children: [
            /* @__PURE__ */ jsx(LandingLinks, {}),
            /* @__PURE__ */ jsx(Global, {
              styles: reset
            }),
            /* @__PURE__ */ jsx(Global, {
              styles: rcCascaderCss
            }),
            /* @__PURE__ */ jsx(Global, {
              styles: animationCss
            })
          ]
        }),
        renderComponent(rootId, content, configs, ssrData)
      ]
    })
  }));
};

export { BuilderComponent };
